import Collapse from "@material-ui/core/Collapse";
import { Theme, makeStyles } from "@material-ui/core/styles";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { SuccessButton } from "../../../../../../../shared/Button/SuccessButton";
import { claimRewardCoin } from "./functions";
import { ClearedQuest } from "./quests/types";

export const claimAllButtonKey = "claimAllButtonKey";

export function ClaimAllButton({
    submitting,
    setSubmitting,
    clearedQuests,
}: {
    submitting: boolean;
    setSubmitting: (submitting: boolean) => void;
    clearedQuests: ClearedQuest[];
}) {
    const rewardTargets = clearedQuests.filter(q => !q.claimed);
    const isShown = rewardTargets.length > 1;
    const c = useStyles({ isShown });

    return (
        <Collapse className={c.container} in={isShown}>
            <SuccessButton
                disabled={submitting}
                className={c.button}
                startIcon={<MonetizationOnIcon />}
                endIcon={<KeyboardArrowRightIcon />}
                onClick={() => {
                    if (!isShown || submitting) {
                        return;
                    }

                    // Coin以外の報酬を実装する場合は、構造を再度考え直す必要がある
                    claimRewardCoin(
                        setSubmitting,
                        rewardTargets.reverse().map(q => ({
                            questKey: q.questKey,
                            questTitle: q.title,
                            coins: q.reward.value,
                            transitionTarget: q.transitionTarget,
                        }))
                    );
                }}
            >
                Claim All Rewards
            </SuccessButton>
        </Collapse>
    );
}
const useStyles = makeStyles<Theme, { isShown: boolean }>({
    container: ({ isShown }) => ({
        marginBottom: isShown ? 7 : 0,
        paddingTop: isShown ? 5 : 0,
        paddingRight: 5,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        transition: "all 500ms",
    }),
    button: {
        maxHeight: 30,
        minHeight: 30,
        fontSize: "15px !important",
        lineHeight: 1,
    },
});

